import React from 'react'
import { type IconProps } from '../IconPropsInterface'

export const Sort: React.FC<IconProps> = ({ color, size, fill }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H13M4 12H13M4 18H13M15 15L18 18M18 18L21 15M18 18V6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
